import type { RouteRecordRaw } from 'vue-router'

const productRoutes: RouteRecordRaw[] = [
  {
    path: '/produk',
    component: () => import('@/views/app/the-layout.vue'),
    children: [
      {
        path: '',
        name: 'product list',
        component: () => import('@/views/app/product/list/page-list.vue'),
        meta: { title: 'List Produk' },
      },
    ],
  },
  {
    path: '/produk/cetak',
    name: 'product print',
    component: () => import('@/views/app/product/print/page-print.vue'),
    meta: { title: 'Cetak Produk' },
  },
]

export default productRoutes
